import Data from '../Data';

import type { MentionSuggestion } from 'common/api/endpoints/mentions';
import type { Dispatch } from 'redux';

export const internalSuggestionsLoaded = 'canny/internal_mention_suggestions/suggestions_loaded';
export const internalSuggestionsError = 'canny/internal_mention_suggestions/suggestions_error';

type SuggestionsLoadedAction = {
  key: string;
  prefix: string;
  suggestions: MentionSuggestion[];
  timestamp: number;
  type: typeof internalSuggestionsLoaded;
};

type SuggestionsErrorAction = {
  error: string;
  key: string;
  prefix: string;
  timestamp: number;
  type: typeof internalSuggestionsError;
};

export type InternalMentionSuggestionsAction = SuggestionsLoadedAction | SuggestionsErrorAction;

function suggestionsLoaded(
  prefix: string,
  suggestions: MentionSuggestion[],
): SuggestionsLoadedAction {
  return {
    key: getInternalMentionQueryKey(prefix),
    prefix,
    suggestions,
    timestamp: Date.now(),
    type: internalSuggestionsLoaded,
  };
}

function suggestionsError(prefix: string, error: string): SuggestionsErrorAction {
  return {
    error,
    key: getInternalMentionQueryKey(prefix),
    prefix,
    timestamp: Date.now(),
    type: internalSuggestionsError,
  };
}

function fetchSuggestions(prefix: string) {
  return (dispatch: Dispatch, getState: () => any) => {
    const cookies = getState().cookies;
    return Data.fetch(
      {
        suggestions: {
          input: {
            prefix,
          },
          query: Data.queries.internalMentionSuggestions,
        },
      },
      cookies,
      (error: string | null, data: { suggestions: MentionSuggestion[] }) => {
        if (error) {
          return dispatch(suggestionsError(prefix, error));
        } else {
          return dispatch(suggestionsLoaded(prefix, data.suggestions));
        }
      },
    );
  };
}

export function loadInternalMentionSuggestions(prefix: string) {
  return (dispatch: Dispatch, getState: () => any) => {
    if (shouldFetchSuggestions(getState(), prefix)) {
      return dispatch(fetchSuggestions(prefix) as any);
    }

    return Promise.resolve();
  };
}

export function getInternalMentionQueryKey(prefix: string): string {
  const queryObject = {
    prefix,
  };
  return JSON.stringify(queryObject);
}

function getInternalMentions(state: any, prefix: string) {
  const queryKey = getInternalMentionQueryKey(prefix);
  return state.internalMentionSuggestions?.[queryKey];
}

function shouldFetchSuggestions(state: any, prefix: string): boolean {
  if (typeof prefix !== 'string' || prefix.length === 0) {
    return false;
  }

  return !getInternalMentions(state, prefix);
}
